import React from "react";
import Carousel from "../components/rentalScreen/Carousel";
import Gallery from "../components/rentalScreen/Gallery";
import LogosSection from "../components/rentalScreen/LogosSection";
import CarsSection from "../components/rentalScreen/CarsSection";

export default function RentalPage() {
	return (
		<>
			<Carousel />
			<Gallery />
			<LogosSection />
			<CarsSection />
		</>
	);
}
